import { Injectable } from "@angular/core";
import { environment } from "src/environments/environment";
import { HttpClient } from "@angular/common/http";

@Injectable({
  providedIn: "root",
})
export class AppService {
  readonly BASE_URL = environment.API_URL;

  constructor(private http: HttpClient) {}

  login(username: string, password: string) {
    var body: any = new FormData();
    body.append("username", username);
    body.append("password", password);
    return this.http
      .post<any>(this.BASE_URL + "api-custom-auth/", body)
      .subscribe(
        (data) => {
          localStorage.setItem("authToken", data.token);
          localStorage.setItem("allIds", data.all_Ids);
          localStorage.setItem(
            "formFilled",
            data.about_team.team_data.formFilled
          );
          localStorage.setItem("name", data.about_team.memb_data.name);
          localStorage.setItem("wDet", data.about_team.memb_data.wDet);
          localStorage.setItem("isReg", data.about_team.team_data.isReg);
          localStorage.setItem("ctry", data.about_team.memb_data.ctry);
          localStorage.setItem("state", data.about_team.memb_data.state);
          localStorage.setItem("city", data.about_team.memb_data.city);
          var values = localStorage.getItem("ctry");
          return true;
        },
        (error) => {
          //Error callback
          console.error(error);
          return false;
        }
      );
  }
}
